import SearchApi from "../api";
import { showError } from "../../util";

const state = {
  searchResults: []
};

const getters = {
  searchResults: state => state.searchResults
};

const mutations = {
  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results;
  },
  RESET_SEARCH_RESULTS(state) {
    state.searchResults = [];
  }
};

const actions = {
  async search({ commit }, text) {
    const searchResults = await SearchApi.search(text).catch(showError.bind(this));
    commit('SET_SEARCH_RESULTS', searchResults);
  },
  resetSearch({ commit }) {
    commit('RESET_SEARCH_RESULTS');
  }
};

export {
  state,
  getters,
  mutations,
  actions
};